<template>
  <div>
    <TitleArea
      :text="text"
      :show-return="showReturn"
      :dense="dense"
      @click-close="onClickClose"
    />
    <div id="content-area" class="content-area" :class="{ noMenu: !isTarget }">
      <slot name="contents" />
    </div>
    <MenuArea v-show="isTarget" />
  </div>
</template>

<script>
import TitleArea from "@/components/Atoms/TitleArea";
import MenuArea from "@/components/Atoms/MenuArea";

export default {
  name: "title-frame",
  components: {
    TitleArea,
    MenuArea,
  },
  props: {
    text: { type: String },
    showReturn: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
  },
  computed: {
    isTarget() {
      return location.pathname === "/";
    },
  },
  methods: {
    onClickClose(e) {
      this.$emit("click-close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.content-area {
  position: fixed;
  z-index: 0;
  width: 100%;
  top: 2.2rem;
  overflow: scroll;
  height: calc(100% - 4.8rem);
  &.noMenu {
    height: calc(100% - 2rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/TitleFrame.vue